import { render } from "./ProjectGrid.vue?vue&type=template&id=1dc60c82"
import script from "./ProjectGrid.vue?vue&type=script&lang=js"
export * from "./ProjectGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/sections/ProjectGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1dc60c82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1dc60c82', __exports__)) {
    api.reload('1dc60c82', __exports__)
  }
  
  module.hot.accept("./ProjectGrid.vue?vue&type=template&id=1dc60c82", () => {
    api.rerender('1dc60c82', render)
  })

}


export default __exports__